import { useEffect, useState } from "react";
import axios from "axios";
import Layout from "./Layout";
import api from "../Api/Api";
import Swal from "sweetalert2";

const Fare = () => {
  const [fares, setFares] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);

  const fetchFares = async () => {
    setPageLoading(true);
    try {
      const res = await api.get("/get_fares/");
      setFares(res.data);
    } catch (err) {
        Swal.fire("Error!", "Failed to fetch fares. Please try again.", "error");
    }finally {
      setPageLoading(false);
    }
  };

  useEffect(() => {
    fetchFares();
  }, []);

  const handleChange = (index, field, value) => {
    const updated = [...fares];
    updated[index][field] = value;
    setFares(updated);
  };

  const handleUpdate = async (fare) => {
    setLoading(true);
    try {
      await api.put(`/update_fare/${fare.vehicle_type}/`, fare);    
        Swal.fire({
        position: "top-end",
        icon: "success",
        title: `${fare.vehicle_type} updated successfully`,
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (err) {
      Swal.fire("Error!", "Failed to update fare. Please try again.", "error");
    }finally {
    setLoading(false);
    }
  };
  
//   check if page is loading
  if (pageLoading) {
  return (
    <Layout title="Fare">
      <div className="flex items-center justify-center h-[70vh]">
        <div className="text-center">
          <div className="w-10 h-10 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-3"></div>
          <p className="text-gray-600">Loading fares...</p>
        </div>
      </div>
    </Layout>
  );
}

  return (
    <Layout title="Fare">
      <div className="p-6">
        <h1 className="text-2xl font-bold mb-6">Fare Management</h1>

        <div className="grid md:grid-cols-2 gap-6">
  {fares.map((fare, index) => (
    <div
      key={fare.vehicle_type}
      className="bg-white shadow-lg rounded-2xl p-6"
    >
      <h2 className="text-xl font-semibold mb-6 capitalize">
        {fare.vehicle_type}
      </h2>

      <div className="space-y-4">

        {/* Base Fare */}
        <div>
          <label className="block text-sm font-medium mb-1">
            Base Fare (Ksh)
          </label>
          <input
            type="number"
            value={fare.base_fare}
            onChange={(e) =>
              handleChange(index, "base_fare", e.target.value)
            }
            className="w-full border p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        {/* Price per KM */}
        <div>
          <label className="block text-sm font-medium mb-1">
            Price per KM (Ksh)
          </label>
          <input
            type="number"
            value={fare.price_per_km}
            onChange={(e) =>
              handleChange(index, "price_per_km", e.target.value)
            }
            className="w-full border p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        {/* Price per Minute */}
        <div>
          <label className="block text-sm font-medium mb-1">
            Price per Minute (Ksh)
          </label>
          <input
            type="number"
            value={fare.price_per_minute}
            onChange={(e) =>
              handleChange(index, "price_per_minute", e.target.value)
            }
            className="w-full border p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        {/* Minimum Fare */}
        <div>
          <label className="block text-sm font-medium mb-1">
            Minimum Fare (Ksh)
          </label>
          <input
            type="number"
            value={fare.minimum_fare}
            onChange={(e) =>
              handleChange(index, "minimum_fare", e.target.value)
            }
            className="w-full border p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        {/* Surge Multiplier */}
        <div>
          <label className="block text-sm font-medium mb-1">
            Surge Multiplier
          </label>
          <input
            type="number"
            step="0.1"
            value={fare.surge_multiplier}
            onChange={(e) =>
              handleChange(index, "surge_multiplier", e.target.value)
            }
            className="w-full border p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        {/* Button */}
        <button
          onClick={() => handleUpdate(fare)}
          disabled={loading}
          className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition"
        >
          {loading ? "Updating..." : "Update"}
        </button>

      </div>
    </div>
  ))}
</div>
      </div>
    </Layout>
  );
};

export default Fare;